import axios from "axios";
import { BASE_API_V1_URL } from "neetocommons/constants";

const update = ({ keyName, payload }) =>
  axios.patch(`${BASE_API_V1_URL}/taxonomies/${keyName}`, payload);

const bulkDestroy = payload =>
  axios.delete(`${BASE_API_V1_URL}/taxonomies/bulk_destroy`, {
    data: payload,
  });

const taxonomiesApi = { update, bulkDestroy };

export default taxonomiesApi;
